import type { ApiClient } from '../client';

// The «Desbloquear» WRITE, the inverse of the block and offered only on a courier account. The
// reason is mandatory and travels in the body, never in the URL: it is free text an agent typed,
// and a path ends up in access logs. 200 with an empty body — the refetched ficha is the receipt.
export async function unblockUser(client: ApiClient, id: string, reason: string): Promise<void> {
  await client.post(`/app_service/panel/v1/users/${encodeURIComponent(id)}/unblock`, { reason });
}
